import { ActivationCodeShortGetDto, PaymentResponsibility } from "../activation-codes";
import { NewRegistrationStatus } from "./new-registration-status";
import { NewRegistrationType } from "./new-registration-type";

export class NewRegistrationModel {
  id: number;
  activationCode: ActivationCodeShortGetDto;
  status: NewRegistrationStatus;
  registrationType: NewRegistrationType;
  subscriptionPlanId: number;
  subscriptionPlanName: string;
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  state: string;
  address: string;
  city: string;
  zip: string;
  country: number;
  companyName: string;
  website?: string;
  sendToEmail?: string;
  linkUrl?: string;
  createdOn: string;
  partnerId?: number;
  partnerName?: string;
  paymentResponsibility: string;
  locationQuantity?: number;
  addons?: NewRegistrationAddon[];
}

export interface NewRegistrationAddon {
  id: number;
}
